import axios from "axios";

const axioss= axios.create({
    baseURL:"https://fakestoreapi.com/"
 })
 export default axioss